module.exports = __webpack_public_path__ + "img/talmid_no.7e18fdd1.png";